import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { MegaMenuItem } from 'primeng/api';

import { LayoutService } from '../../services/layout.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { AuthenticationService } from 'src/app/authentication/services/authentication.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { signOutRequestModel, signOutResponseModel } from 'src/app/authentication/models/sign-out';
import { Router } from '@angular/router';
import { routingAuthenticationModuleType, routingModuleType } from 'src/app/shared/enums/module-types';
import { Language } from 'src/app/shared/models/language';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { staffResponseModel } from 'src/app/organization/models/staff';
import { SharedService } from 'src/app/shared/services/shared.service';
import { StaffsService } from 'src/app/organization/services/staffs.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { notificationResponseModel } from 'src/app/authentication/models/user-group';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent extends BaseComponent implements OnInit {
    private unsubscribe = new Subject<void>();
    sign_out_request: signOutRequestModel = new signOutRequestModel;
    @ViewChild('overlayPanel') overlayPanel!: OverlayPanel;
    @ViewChild('notification') notification!: OverlayPanel;
    @ViewChild('profile') profile!: OverlayPanel;

    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

    @ViewChild('searchInput') searchInput!: ElementRef;
    languages: Language[];
    selected_language: Language = new Language({});
    imageSrc: string = '';
    userProfileImage: string = '';
    defaultImage: string = 'assets/demo/images/avatar/amyelsner.png';
    current_page: number;
    items_per_page: number;
    notification_list: any;
    loading: boolean = false;
    notification_count: any;
    displayName: string = '';
    private displayNameSubscription: Subscription;

    constructor(
        public el: ElementRef,
        private router: Router,

        public layoutService: LayoutService,
        private spinnerService: SpinnerService,
        private storageService: StorageService,
        private authenticationService: AuthenticationService,
        public translation_service: TranslationService,
        private toaster_service: ToasterService,
        public staffs_service: StaffsService,
        public shared_service: SharedService,
    ) {
        super();
        this.getProfileData(this.storageService.getUserId());
        this.staffs_service.userProfile.subscribe((res: any) => {
            this.userProfileImage = res.data;
        });
    }

    ngOnInit(): void {

        this.authenticationService.tab.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.loadNotificaionCount();
        });
        this.languages = [
            { title: 'English', value: 'en', image: '../../../../assets/images/layout/en.png' },
            { title: 'Arabic', value: 'ar', image: '../../../../assets/images/layout/ar.png' }
        ];
        this.displayNameSubscription = this.staffs_service.currentDisplayName$.subscribe((displayName) => {
            this.displayName = displayName;
          });

        this.changeLanguage(this.storageService.getLanguage());
        this.getDefault();
        this.current_page = this.shared_service.getPage();
        this.items_per_page = this.shared_service.getLimit();
        this.loadNotificaionCount();
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
        if (this.displayNameSubscription) {
            this.displayNameSubscription.unsubscribe();
          }
    }

    getDefault() {
        return this.shared_service.getDefaultImage();
    }

    getProfileData(staffId: string) {
        this.staffs_service.getStaff(staffId).subscribe({
            next: (responses: staffResponseModel) => {
                if (responses.result == 1) {
                    if (responses.data.profile_image !== "") {
                        this.userProfileImage = this.shared_service.getHostUrl() + responses.data.profile_image;
                    } else {
                        this.userProfileImage = "";
                    }
                    this.displayName = responses.data.display_name

                }
                else if (responses.result == 0) {
                    this.toaster_service.showError(responses.error.message[0]);
                } else {
                    this.toaster_service.showError(responses.stackTrace);
                }
            },
            error: (error) => {
                this.toaster_service.showError(error);
            },
            complete: () => {
                // this.spinner_service.hide();
            }

        })
    }

    changeLanguage(language?: any) {
        this.storageService.setLanguage(language);
        this.translation_service.use(language);
        //const profileDiv = document.querySelector('.overlayPanel');
        this.overlayPanel?.hide(); // 
        if (language === 'en') {
            this.imageSrc = '../../../../assets/images/layout/en.png';
        } else {
            this.imageSrc = '../../../../assets/images/layout/ar.png';
        }
    }


    activeItem!: number;

    model: MegaMenuItem[] = [
        {
            label: 'UI KIT',
            items: [
                [
                    {
                        label: 'UI KIT 1',
                        items: [
                            { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
                            { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
                            { label: 'Float Label', icon: 'pi pi-fw pi-bookmark', routerLink: ['/uikit/floatlabel'] },
                            { label: 'Button', icon: 'pi pi-fw pi-mobile', routerLink: ['/uikit/button'] },
                            { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] }
                        ]
                    }
                ],
                [
                    {
                        label: 'UI KIT 2',
                        items: [
                            { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
                            { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
                            { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
                            { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
                            { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] }
                        ]
                    }
                ],
                [
                    {
                        label: 'UI KIT 3',
                        items: [
                            { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
                            { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
                            { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
                            { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
                            { label: 'Misc', icon: 'pi pi-fw pi-circle-off', routerLink: ['/uikit/misc'] }
                        ]
                    }
                ]
            ]
        },
        {
            label: 'UTILITIES',
            items: [
                [
                    {
                        label: 'UTILITIES 1',
                        items: [
                            { label: 'Icons', icon: 'pi pi-fw pi-prime', routerLink: ['utilities/icons'] },
                            { label: 'PrimeFlex', icon: 'pi pi-fw pi-desktop', url: 'https://www.primefaces.org/primeflex/', target: '_blank' }
                        ]
                    }
                ],

            ]
        }
    ];

    get mobileTopbarActive(): boolean {
        return this.layoutService.state.topbarMenuActive;
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onRightMenuButtonClick() {
        this.layoutService.openRightSidebar();
    }

    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }

    focusSearchInput() {
        setTimeout(() => {
            this.searchInput.nativeElement.focus()
        }, 0);
    }

    async signOut() {
        this.spinnerService.show();
        this.sign_out_request.refresh = this.storageService.getRefreshToken();
        const formdata = {
            fcm_token: this.storageService.getFcmToken()
        }

        await this.authenticationService.unSubscribeUser(formdata).subscribe({
            next: (response) => {
                console.log(response);
                this.authenticationService.signOut(this.sign_out_request).subscribe({
                    next: async (response: signOutResponseModel) => {
                        if (response.result == 1) {
                            this.router.navigate([routingModuleType.authentication, routingAuthenticationModuleType.signin]);
                            this.storageService.clearLocalStorageInfo();
                        } else if (response.result == 0) {
                            if (response.error.refresh) {
                                this.toaster_service.showError(response.error.refresh[0])
                            }
                        } else {
                            this.toaster_service.showError(response.stackTrace)
                        }
                    },
                    error: (error: any) => {
                        this.toaster_service.showError(error.message)
                        this.spinnerService.hide();
                    },
                    complete: () => {
                        this.spinnerService.hide();
                    }
                });
            },
            error: (error: any) => {
                console.log(error);
            },
            complete: () => {
                console.log();
            }
        });
    }

    async signOutAllDevice() {
        this.spinnerService.show();
        this.sign_out_request.refresh = this.storageService.getRefreshToken();
        this.closeDilogBox();
        const formdata = {
            fcm_token: this.storageService.getFcmToken()
        }

        this.authenticationService.unSubscribeUser(formdata).subscribe({
            next: (response) => {
                console.log(response);
                this.authenticationService.signOutAllDevice(this.sign_out_request).subscribe({
                    next: async (response: signOutResponseModel) => {
                        if (response.result == 1) {
                            this.router.navigate([routingModuleType.authentication, routingAuthenticationModuleType.signin]);
                            this.storageService.clearLocalStorageInfo();
                        } else if (response.result == 0) {
                            if (response.error.refresh) {
                                this.toaster_service.showError(response.error.refresh[0])
                            }
                        } else {
                            this.toaster_service.showError(response.stackTrace)
                        }
                    },
                    error: (error: any) => {
                        this.toaster_service.showError(error.message)
                        this.spinnerService.hide();
                    },
                    complete: () => {
                        this.spinnerService.hide();
                    }
                });
            },
            error: (error: any) => {
                console.log(error);
            },
            complete: () => {
                console.log();
            }
        });
    }

    switchOrganization() {
        this.router.navigate([routingModuleType.authentication, routingAuthenticationModuleType.user_organizations]);
        this.profile?.hide();
        this.storageService.clearUserStorageInfo();
    }

    closeDilogBox() {
        const profileDiv = document.querySelector('.profile-settings-div');
        if (profileDiv) {
            profileDiv.classList.add('ng-hidden');
        }
    }

    toggleProfilesetting() {
        this.profile?.hide();
        this.router.navigate([this.routingModuleType.organization, this.routingModuleType.profile])
            .then(() => {
                this.closeDilogBox();
            });
    }

    loadNotificaionCount() {
        this.authenticationService.getNotificationCount().subscribe({
            next: (response: any) => {
                if (response.result == 1) {
                    this.notification_count = response.data;
                } else if (response.result == 0) {
                    if (response.error.message) {
                        this.toaster_service.showError(response.error.message[0])
                    }
                } else {
                    this.toaster_service.showError(response.stackTrace);
                }
            },
            error: (error: any) => {
                this.spinnerService.hide();
                this.toaster_service.showError(error, true);
            },
            complete: () => {
                this.spinnerService.hide();
            }
        })
    }

    get rightMenuActive(): boolean {
        return this.layoutService.state.rightMenuActive;
    }

    set rightMenuActive(_val: boolean) {
        this.layoutService.state.rightMenuActive = _val;
    }
}
